/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyScopeFilter } from './companyScopeFilter';
import { CompanyIncludeFilterItems } from './companyIncludeFilterItems';


export interface CompanyIncludeFilterInner { 
    relation?: CompanyIncludeFilterInner.RelationEnum;
    scope?: CompanyScopeFilter;
}
export namespace CompanyIncludeFilterInner {
    export type RelationEnum = 'businessUnits';
    export const RelationEnum = {
        BusinessUnits: 'businessUnits' as RelationEnum
    };
}


